module.exports = __webpack_public_path__ + "static/media/meet-us-personal-yellow-lines.d07808a5.svg";